export interface PersonalInfo {
  name: string;
  title: string;
  bio: string;
  shortBio?: string;
  location?: string;
  email?: string;
  github?: string;
  linkedin?: string;
  resume?: string;
}

export const personalInfo: PersonalInfo = {
  name: 'Jude Lwin',
  title: 'Software Engineer',
  bio: "I'm a UMD computer science student who likes building things that feel real: systems that run reliably, tools people actually use, and projects that make a messy idea click into place. Outside of code, I'm usually playing games with friends, hunting for good food, or finding another place to eat even though I definitely just ate.",
  shortBio: 'Computer science student at UMD focused on backend infrastructure, distributed systems, and applied machine learning.',
  github: 'https://github.com/judelwin',
  linkedin: 'https://www.linkedin.com/in/jude-lwin/',
  resume: '/jude_lwin_resume.pdf',
};
